import { primaryMain, secondaryMain, white } from 'themes/colors';

export default {
  message: {
    fontSize: '22px',
    lineHeight: '28px',
    fontWeight: 'normal',
    padding: '50px 50px 50px 150px',
  },
  listings: {
    padding: '0px 10px',
  },
  map: {
    gridColumnStart: 3,
    gridColumnEnd: 4,
    margin: '0px 0px 0px 0px',
    minWidth: 0,
    '@media screen and (max-width: 600px)': {
      gridColumnStart: '1 !important',
      gridColumnEnd: '-1 !important',
      gridRow: 'auto',
      maxWidth: '100%',
    },
  },
  sidenav: {
    gridColumnStart: 1,
    gridColumnEnd: 2,
    width: '0px',
    overflowX: 'hidden',
    transition: 'width 0.5s linear',
    '@media screen and (max-width: 600px)': {
      width: '0 !important',
    },
  },
  sideNavContent: {
    display: 'grid',
    gridColumnStart: 1,
    gridColumnEnd: 2,
    gridRowStart: 1,
    gridRowEnd: 2,
    width: '400px',
    height: '1215px',
    opacity: 0,
    visibility: 'hidden',
    alignContent: 'start',
    gridTemplateRows: 'fit-content(0px)',
    padding: '30px 0px 0px 15px',
    fontSize: '16px',
    backgroundColor: 'white',
    transition: 'opacity 0.5s linear',
    boxShadow: `0 1px 2px rgba(0,0,0,0.07), 
                0 2px 4px rgba(0,0,0,0.07), 
                0 4px 8px rgba(0,0,0,0.07), 
                0 8px 16px rgba(0,0,0,0.07),
                0 16px 32px rgba(0,0,0,0.07), 
                0 32px 64px rgba(0,0,0,0.07)`,
    '@media screen and (max-width: 600px)': {
      position: 'fixed',
      top: 56,
      left: 0,
      width: '100%',
      maxWidth: '100%',
      height: 'auto',
      maxHeight: 'calc(100vh - 56px)',
      overflowY: 'auto',
      zIndex: '6 !important',
      backgroundColor: 'white',
    },
  },
  statusFilter: {
    display: 'grid',
    gridAutoFlow: 'row',
    padding: '0px 0px 0px 25px',
    width: '100%',
  },
  filters: {
    display: 'grid',
    gridAutoFlow: 'row',
    padding: '0px 0px 0px 25px',
    width: '100%',
    maxHeight: '300px',
    overflowY: 'scroll',
  },
  labelAndChips: {
    marginTop: '30px',
    gridColumnStart: 1,
    gridColumnEnd: 2,
    gridRowStart: 1,
    gridRowEnd: 2,
    justifySelf: 'start',
    padding: '0px 0px 0px 10px',
    transition: 'margin 0.5s linear',
    zIndex: 4,
    maxHeight: '50px',
    '@media screen and (max-width: 600px)': {
      maxHeight: 'none',
      marginLeft: '0 !important',
    },
  },
  mapToggle: {
    marginTop: '30px',
    marginRight: '10px',
    gridColumnStart: 1,
    gridColumnEnd: 2,
    gridRowStart: 1,
    gridRowEnd: 2,
    justifySelf: 'end',
    '@media screen and (max-width: 600px)': {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      gap: '8px',
      marginTop: '4px',
      marginLeft: '10px',
      marginBottom: '8px',
      justifySelf: 'stretch',
      gridRowStart: 2,
      gridRowEnd: 3,
      justifyContent: 'space-between',
      '& .MuiToggleButton-root': {
        padding: '8px',
      },
      zIndex: 4,
    },
  },
  listingsAndMap: {
    display: 'grid',
    gridColumnStart: 1,
    gridColumnEnd: 2,
    gridRowStart: 1,
    gridRowEnd: 2,
    gridTemplateColumns: 'fit-content(0px) 1fr 1fr',
    margin: '105px 0px 0px 10px',
    zIndex: 2,
    '@media screen and (max-width: 600px)': {
      gridColumn: '1 / -1',
      gridRowStart: 3,
      gridRowEnd: 4,
      gridTemplateColumns: 'minmax(0, 1fr) !important',
      margin: '12px 0 0 0',
      width: '100%',
      maxWidth: '100%',
      minWidth: 0,
    },
  },
  listingsColumn: {
    minWidth: 0,
    '@media screen and (max-width: 600px)': {
      gridColumnStart: '1 !important',
      gridColumnEnd: '-1 !important',
      maxWidth: '100%',
    },
  },
  filterButton: {
    transition: 'opacity 0.5s linear',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'end',
    '@media screen and (max-width: 600px)': {
      alignItems: 'stretch',
    },
  },
  filterRow: {
    display: 'grid',
    gridAutoFlow: 'column',
    padding: '0px 10px',
    width: '100%',
    '@media screen and (max-width: 600px)': {
      gridTemplateColumns: '1fr 1fr',
      gap: '8px',
      padding: '0 10px',
      alignItems: 'end',
    },
  },
  sortBox: {
    width: '175px',
    justifySelf: 'end',
    '@media screen and (max-width: 600px)': {
      width: 'auto',
      justifySelf: 'stretch',
    },
  },
  createListingButton: {
    color: white,
    backgroundColor: primaryMain,
    '&:hover': {
      backgroundColor: secondaryMain,
      cursor: 'hand',
    },
    marginRight: 16,
    marginBottom: 16,
    '@media screen and (max-width: 600px)': {
      marginRight: 0,
      marginBottom: 0,
      minHeight: 40,
    },
  },
  filterButtonStyle: {
    minWidth: '125px',
    '@media screen and (max-width: 600px)': {
      width: '100%',
      minWidth: 0,
    },
    color: white,
    backgroundColor: primaryMain,
    '&:hover': {
      backgroundColor: secondaryMain,
      cursor: 'hand',
    },
  },
  checkbox: {
    color: primaryMain,
    '&.Mui-checked': {
      color: primaryMain,
    },
  },
};
